module.exports = __webpack_public_path__ + "static/media/restricted.48d979d5.jpg";